import type { Product } from '../types';
import { apiUrl } from './config';

type ProductsResponse = { products: Product[] };

export async function getProducts(): Promise<Product[]> {
    const resp = await fetch(apiUrl('/api/products'));
    if (!resp.ok) throw new Error('Failed to load products');
    const data = (await resp.json()) as ProductsResponse;
    return data.products;
}

/* ---------- Categories ---------- */

export type Category = {
    slug: string;
    title: string;
    description: string;
    imageUrl?: string;
};

type CategoriesResponse = { categories: Category[] };

export async function getCategories(): Promise<Category[]> {
    const resp = await fetch(apiUrl('/api/categories'));
    if (!resp.ok) throw new Error('Failed to load categories');
    const data = (await resp.json()) as CategoriesResponse;
    return data.categories;
}

/* ---------- Delivery Slots ---------- */

export type DeliverySlotsResponse = {
    ok: boolean;
    date: string;
    slots: { time: string; available: boolean }[];
};

export async function getDeliverySlots(): Promise<DeliverySlotsResponse> {
    const resp = await fetch(apiUrl('/api/delivery-slots'));
    if (!resp.ok) throw new Error('Failed to load delivery slots');
    const data = (await resp.json()) as DeliverySlotsResponse;
    return data;
}

/* ---------- Orders ---------- */

export type CreateOrderPayload = {
    items: { productId: number; quantity: number }[];
    customerName: string;
    customerAddress: string;
    telegramUsername: string;
    deliverySlot: string;
    note?: string;
    telegramUserId?: string;
};

export type CreateOrderError = Error & {
    status?: number;
    fields?: Record<string, string>;
};

export async function createOrder(payload: CreateOrderPayload): Promise<{ orderId: string; total: number; deliverySlot: string }> {
    const resp = await fetch(apiUrl('/api/orders'), {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
    });
    const data = (await resp.json().catch(() => ({}))) as any;

    if (!resp.ok) {
        const err: CreateOrderError = new Error(data?.message ?? data?.error ?? 'Impossibile creare l\'ordine');
        err.status = resp.status;
        err.fields = data?.fields;
        throw err;
    }

    if (!data?.ok) {
        const err: CreateOrderError = new Error(data?.message ?? 'Ordine non completato');
        err.status = resp.status;
        err.fields = data?.fields;
        throw err;
    }
    return {
        orderId: data.orderId,
        total: data.total,
        deliverySlot: data.deliverySlot,
    };
}
